// DS: C35
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import UserAvatar from '../../../User/Avatar';
import Author from '../../_partials/Author';
import GroupDetail from '../../_partials/GroupDetail';
import Title from '../../_partials/Title';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import Premium from '@wix/da-ds/pkg/Icons/24x24/Premium';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import TextTooltipOnHover from '../../../Popover/Preset/TextTooltipOnHover';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { getDeviationTitle } from '../../../DeviationViews/_helpers';
import { isLongTitle } from '../../helpers';
import { useSelector } from 'react-redux';
import { getCurrentUser } from '../../../publicSession/selectors';
import s from './DesktopSubmissionDetails.scss';
const DesktopSubmissionDetails = ({ className , deviation , deviation: { author , extended , digitalAsset  } , isOwner , showTitle  })=>{
    var _das_asset, _das_asset_creator, _das_asset1, _das_asset_owner;
    const { t  } = useTranslation();
    const deviationTitle = getDeviationTitle(deviation);
    const currentUser = useSelector(getCurrentUser);
    const noTitle = !deviationTitle || !showTitle;
    const { isPremium , isPaidFolder  } = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData);
    // This is utter BS, reality would need to consider more
    const das = digitalAsset;
    if (das && !das.hasEditions && das.asset && ((_das_asset = das.asset) === null || _das_asset === void 0 ? void 0 : (_das_asset_creator = _das_asset.creator) === null || _das_asset_creator === void 0 ? void 0 : _das_asset_creator.userId) !== ((_das_asset1 = das.asset) === null || _das_asset1 === void 0 ? void 0 : (_das_asset_owner = _das_asset1.owner) === null || _das_asset_owner === void 0 ? void 0 : _das_asset_owner.userId)) {
        var _digitalAsset_creator, _digitalAsset_asset, _digitalAsset_asset_owner;
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['root'], s['das-root'], className)
        }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
            value: {
                sectionname: 'author'
            }
        }, !noTitle && /*#__PURE__*/ React.createElement(Title, {
            title: deviationTitle,
            showTitle: showTitle,
            className: classnames(s['title'], isPremium && s['title-with-folder-icon'])
        }), /*#__PURE__*/ React.createElement("div", {
            className: s['das']
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['das-item']
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['das-item-tag']
        }, "Creator"), /*#__PURE__*/ React.createElement("div", {
            className: s['das-item-user']
        }, /*#__PURE__*/ React.createElement(UserAvatar, {
            withTooltip: true,
            relatedItemBiData: {
                typeid: deviation.typeId,
                itemid: deviation.deviationId
            },
            size: 50,
            user: das.asset.creator,
            className: s['avatar']
        }), /*#__PURE__*/ React.createElement(Author, {
            author: das.asset.creator,
            isOwner: currentUser.userId === (digitalAsset === null || digitalAsset === void 0 ? void 0 : (_digitalAsset_creator = digitalAsset.creator) === null || _digitalAsset_creator === void 0 ? void 0 : _digitalAsset_creator.userId),
            withByline: false
        }))), /*#__PURE__*/ React.createElement("div", {
            className: s['das-item']
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['das-item-tag']
        }, "Owner"), /*#__PURE__*/ React.createElement("div", {
            className: s['das-item-user']
        }, /*#__PURE__*/ React.createElement(UserAvatar, {
            withTooltip: true,
            relatedItemBiData: {
                typeid: deviation.typeId,
                itemid: deviation.deviationId
            },
            size: 50,
            user: das.asset.owner,
            className: s['avatar']
        }), /*#__PURE__*/ React.createElement(Author, {
            author: das.asset.owner,
            isOwner: currentUser.userId === (digitalAsset === null || digitalAsset === void 0 ? void 0 : (_digitalAsset_asset = digitalAsset.asset) === null || _digitalAsset_asset === void 0 ? void 0 : (_digitalAsset_asset_owner = _digitalAsset_asset.owner) === null || _digitalAsset_asset_owner === void 0 ? void 0 : _digitalAsset_asset_owner.userId),
            withByline: false
        }))))));
    }
    var _extended_exclusiveGroup, _extended_originalAuthor, _extended_originalAuthor1;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionname: 'author'
        }
    }, author && /*#__PURE__*/ React.createElement(UserAvatar, {
        withTooltip: true,
        relatedItemBiData: {
            typeid: deviation.typeId,
            itemid: deviation.deviationId
        },
        size: 50,
        user: (_extended_exclusiveGroup = extended === null || extended === void 0 ? void 0 : extended.exclusiveGroup) !== null && _extended_exclusiveGroup !== void 0 ? _extended_exclusiveGroup : author,
        className: s['avatar']
    }), noTitle ? /*#__PURE__*/ React.createElement("div", {
        className: s['no-title']
    }, (extended === null || extended === void 0 ? void 0 : extended.exclusiveGroup) ? /*#__PURE__*/ React.createElement("div", {
        className: s['group-author']
    }, /*#__PURE__*/ React.createElement(GroupDetail, {
        group: extended.exclusiveGroup,
        className: s['left']
    }), /*#__PURE__*/ React.createElement(Author, {
        author: (_extended_originalAuthor = extended.originalAuthor) !== null && _extended_originalAuthor !== void 0 ? _extended_originalAuthor : author,
        isOwner: isOwner,
        className: classnames(s['left'], s['original-author'])
    })) : /*#__PURE__*/ React.createElement(Author, {
        author: author,
        isOwner: isOwner,
        className: s['left']
    })) : /*#__PURE__*/ React.createElement("div", {
        className: s['right']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title-row']
    }, isPremium && /*#__PURE__*/ React.createElement(TextTooltipOnHover, {
        tooltipText: isPaidFolder ? t('deviation.details.premiumFolder.tooltip') : t('deviation.details.watchersOnlyFolder.tooltip'),
        className: classnames(s['folder-icon'], isLongTitle(deviationTitle) && s['folder-icon-long-title'])
    }, isPaidFolder ? /*#__PURE__*/ React.createElement(Premium, {
        size: IconSize.SMALL
    }) : /*#__PURE__*/ React.createElement(EyeDisc2, {
        size: IconSize.SMALL
    })), /*#__PURE__*/ React.createElement(Title, {
        title: deviationTitle,
        showTitle: showTitle,
        className: classnames(s['title'], isPremium && s['title-with-folder-icon'])
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['author-row']
    }, (extended === null || extended === void 0 ? void 0 : extended.exclusiveGroup) ? /*#__PURE__*/ React.createElement("div", {
        className: s['group-author']
    }, /*#__PURE__*/ React.createElement(GroupDetail, {
        group: extended.exclusiveGroup
    }), /*#__PURE__*/ React.createElement(Author, {
        author: (_extended_originalAuthor1 = extended.originalAuthor) !== null && _extended_originalAuthor1 !== void 0 ? _extended_originalAuthor1 : author,
        isOwner: isOwner,
        className: s['original-author']
    })) : /*#__PURE__*/ React.createElement(Author, {
        author: author,
        isOwner: isOwner
    })))));
};
DesktopSubmissionDetails.displayName = 'DesktopSubmissionDetails';
export default DesktopSubmissionDetails;
